import React, { Component } from "react";
import { firebase, opdrachten } from "../../models/firestore";
import Opdracht from "./Opdracht";
import Button from "@material-ui/core/Button";
import Paper from "@material-ui/core/Paper";
import AddCircle from "@material-ui/icons/AddCircle";
import ImportExport from "@material-ui/icons/ImportExport";
import EmailOutlined from "@material-ui/icons/EmailOutlined";
import OfflinePin from "@material-ui/icons/OfflinePin";
import DoneOutline from "@material-ui/icons/DoneOutline";
import Done from "@material-ui/icons/Done";
import New from "@material-ui/icons/FiberNew";
import { confirmAlert } from "react-confirm-alert"; // Import
import "../react-confirm-alert.css"; // Import css
import { ToastContainer, toast, Zoom } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { withStyles } from "@material-ui/core/styles";
import { observer } from "mobx-react";
import ReactTable from "react-table";
import "react-table/react-table.css";
import matchSorter from "match-sorter";

const styles = {
  container: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    position: "relative"
  },
  loader: {
    position: "absolute",
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center"
  },
  header: {
    padding: 16,
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    borderBottom: "1px solid #DDD"
  },
  content: {
    flex: 1,
    overflowY: "scroll"
  },
  add: {
    position: "absolute",
    top: 0,
    right: 0,
    height: 20
  }
};
const Opdrachten = observer(
  class Opdrachten extends Component {
    constructor(props) {
      super(props);
      this.state = {
        disabled: false,
        displayNaam: "",
        rollen: "",
        showall: false,
        showritten: false,
        showretourteboeken: false,
        prevQuery: undefined,
        currentFilter: ""
      };
    }
    componentDidMount() {
      // const editable =
      //   this.props.gebruikersrollen.search("admin") > -1 ||
      //   this.props.gebruikersrollen.search("kantoor") > -1;
      // this.setState({
      //   disabled: !editable
      // });
      //opdrachten.query = ref => ref.orderBy('timestamp');
      //opdrachten.query = ref => ref.where("typeopdracht", "==", "Chauffeur");
      //this.setState({ showretourteboeken: true });
      this.setState({ showalltop50: true });

      // opdrachten.query = ref =>
      //   ref
      //     // .where('datumuitvoering', '==', Date.now() //+ 7 * 24 * 60 * 60 * 1000)
      //     //.orderBy('timestamp', 'desc')
      //     .orderBy('uitvoeringsdatumtimestamp')
      //     .endAt(Date.now() + 7 * 24 * 60 * 60 * 1000)
      //     .limit(20);
      //.orderBy("timestamp");
      //to reset query: opdrachten.query = undefined
    }

    componentDidUpdate(prevProps, prevState) {
      //console.log(opdrachten.query);
      if (prevState.showall !== this.state.showall) {
        if (this.state.showall) {
          confirmAlert({
            customUI: ({ onClose }) => {
              return (
                <div className="custom-ui">
                  <h3>Weet u het zeker?</h3>
                  <p>
                    Alle opdrachten ophalen is alleen noodzakelijk als je een
                    specifieke opdracht wilt zoeken.
                  </p>
                  <p>Gebruik liever de knop Alle opdrachten top 50</p>

                  <button
                    style={{ marginRight: 20 }}
                    onClick={() => {
                      this.setState({
                        showritten: false,
                        showretourteboeken: false,
                        showalltop50: false,
                        showtelefoonopdrachten: false,
                        showtedupliceren: false,
                        showongemaild: false
                      });

                      opdrachten.query = undefined;
                      onClose();
                    }}
                  >
                    Ja, haal alle documenten op
                  </button>
                  <button
                    onClick={() => {
                      // this.setState({
                      //   showalltop50: true,
                      //   showall: false,
                      //   showritten: false,
                      //   showtelefoonopdrachten: false,
                      //   showretourteboeken: false
                      // });
                      onClose();
                    }}
                  >
                    Nee, ik gebruik de knop alle opdrachten top 50.
                  </button>
                </div>
              );
            }
          });
        }
        return null;
      }

      if (prevState.showalltop50 !== this.state.showalltop50) {
        //alert("Nu records filter");
        if (this.state.showalltop50) {
          this.setState({
            showritten: false,
            showretourteboeken: false,
            showall: false,
            showtelefoonopdrachten: false,
            showtedupliceren: false,
            showongemaild: false,
            openstaand: false
          });
          opdrachten.query = ref =>
            ref.where("opdrachtuitgevoerd", "==", false);
        }
        return null;
      }

      if (prevState.showritten !== this.state.showritten) {
        if (this.state.showritten) {
          //alert("Nu records filter");
          this.setState({
            //prevQuery: opdrachten.query,
            showall: false,
            showretourteboeken: false,
            showtelefoonopdrachten: false,
            showalltop50: false,
            showtedupliceren: false,
            showongemaild: false,
            openstaand: false
          });
          //console.log('Deze wil ik zien');
          opdrachten.query = ref =>
            ref
              //
              //
              .where("opdrachtuitgevoerd", "==", false)
              .where("herhaling", "==", true)
              .where("typeopdracht", ">=", "Chauffeur");
          //.orderBy("uitvoeringsdatumtimestamp", "desc");
          //.endAt(5);
          //.endAt(Date.now() + 2 * 24 * 60 * 60 * 1000);
          //.limit(10);
          //.orderBy("uitvoeringsdatumtimestamp", "desc");
          //;
        }

        // else {
        //   // console.log('Waarom niet');
        //   opdrachten.query = this.state.prevQuery;
        //}
        return null;
      }
      // I8rqWu4avtOaiD3ztUqI

      // if (prevState.showtedupliceren !== this.state.showtedupliceren) {
      //   //alert("Nu records filter");
      //   if (this.state.showtedupliceren) {
      //     this.setState({
      //       //prevQuery: opdrachten.query,
      //       showall: false,
      //       showretourteboeken: false,
      //       showtelefoonopdrachten: false,
      //       showalltop50: false,
      //       showritten: false,
      //       showongemaild: false,
      //       openstaand: false
      //     });
      //     //console.log('Deze wil ik zien');
      //     opdrachten.query = ref =>
      //       ref
      //         .where('opdrachtuitgevoerd', '==', true)
      //         .where('opmerking', '>', '')
      //         .where('herhaling', '==', true)
      //         .where('herhaling1week', '==', false)
      //         .where('herhaling2week', '==', false);
      //     //.where('achternaam', '==', 'Cooks');

      //     //.where("typeopdracht", "==", "ChauffeurInstellingen");
      //   }

      //   // else {
      //   //   // console.log('Waarom niet');
      //   //   opdrachten.query = this.state.prevQuery;
      //   //}
      //   return null;
      // }

      if (prevState.showtedupliceren !== this.state.showtedupliceren) {
        //alert("Nu records filter");
        if (this.state.showtedupliceren) {
          this.setState({
            //prevQuery: opdrachten.query,
            showall: false,
            showretourteboeken: false,
            showtelefoonopdrachten: false,
            showalltop50: false,
            showritten: false,
            showongemaild: false,
            openstaand: false
          });
          //console.log('Deze wil ik zien');
          opdrachten.query = ref =>
            ref
              .where("opdrachtuitgevoerd", "==", false)
              .where("herhaling", "==", true);
          //.where("typeopdracht", "==", "ChauffeurInstellingen");
        }

        // else {
        //   // console.log('Waarom niet');
        //   opdrachten.query = this.state.prevQuery;
        //}
        return null;
      }

      if (
        prevState.showtelefoonopdrachten !== this.state.showtelefoonopdrachten
      ) {
        //alert("Nu records filter");

        //Let op je kunt filteredarr gebruiken om extra velden uit te filteren.

        if (this.state.showtelefoonopdrachten) {
          this.setState({
            //prevQuery: opdrachten.query,
            showall: false,
            showretourteboeken: false,
            showritten: false,
            showalltop50: false,
            showtedupliceren: false,
            showongemaild: false,
            openstaand: false
          });
          //console.log('Deze wil ik zien');
          opdrachten.query = ref =>
            ref
              .where("opdrachtuitgevoerd", "==", false)
              .where("herhaling", "==", false);

          //.where("typeopdracht", ">=", "C");

          //.where("typeopdracht", "==", "ChauffeurInstellingen");
        }
        return null;
      }

      if (prevState.showretourteboeken !== this.state.showretourteboeken) {
        if (this.state.showretourteboeken) {
          this.setState({
            // prevQuery: opdrachten.query,
            showall: false,
            showritten: false,
            showtelefoonopdrachten: false,
            showalltop50: false,
            showtedupliceren: false,
            showongemaild: false,
            openstaand: false
          });
          //alert('showretourteboeken');
          opdrachten.query = ref =>
            ref
              .where("typeopdracht", ">=", "Chauffeur")
              .where("typeopdracht", "<=", "ChauffeurInstellingen")
              .where("opdrachtuitgevoerd", "==", false);
          // .where("retourgeboekt", "==", "undefined")
          //.orderBy("uitvoeringsdatumtimestamp", "desc")
          //.endAt(Date.now() + 7 * 24 * 60 * 60 * 1000)
          //.limit(500);
        }
        // else {
        //   opdrachten.query = this.state.prevQuery;
        // }
        return null;
      }
      if (prevState.showongemaild !== this.state.showongemaild) {
        if (this.state.showongemaild) {
          this.setState({
            // prevQuery: opdrachten.query,
            showall: false,
            showritten: false,
            showtelefoonopdrachten: false,
            showalltop50: false,
            showtedupliceren: false,
            showretourteboeken: false,
            openstaand: false
          });
          //alert('showretourteboeken');
          opdrachten.query = ref => ref;
          //.where("geemaild", "==", true);
          //.where("typeopdracht", "<=", "ChauffeurInstellingen")
          // .where("retourgeboekt", "==", "undefined")
          //.orderBy("uitvoeringsdatumtimestamp", "desc")
          //.endAt(Date.now() + 7 * 24 * 60 * 60 * 1000)
          //.limit(150);
        }
        // else {
        //   opdrachten.query = this.state.prevQuery;
        // }
        return null;
      }
      if (prevState.openstaand !== this.state.openstaand) {
        //alert("openstaand");
        if (this.state.openstaand) {
          this.setState({
            // prevQuery: opdrachten.query,
            showall: false,
            showritten: false,
            showtelefoonopdrachten: false,
            showalltop50: false,
            showtedupliceren: false,
            showretourteboeken: false,
            showongemaild: false
          });
          //alert('showretourteboeken');
          opdrachten.query = ref =>
            ref.where("opdrachtuitgevoerd", "==", false);
          //.where("typeopdracht", "<=", "ChauffeurInstellingen")
          // .where("retourgeboekt", "==", "undefined")
          //.orderBy("uitvoeringsdatumtimestamp", "desc")
          //.endAt(Date.now() + 7 * 24 * 60 * 60 * 1000)
          //.limit(150);
        }
        // else {
        //   opdrachten.query = this.state.prevQuery;
        // }
        return null;
      }
      //console.log(opdrachten.query);
    }

    onPressAdd = async () => {
      try {
        await opdrachten.add({
          typeopdracht: "Nieuwe opdracht",
          timestamp: Date.now(),
          datumopdracht: new Date().toDateString("yyyy-MM-dd")
        });
      } catch (err) {
        alert(err);
      }
    };

    // Indien showall dan all andere filters uitzetten. (Ook in ComponentDidUpdate())
    ShowAll = async () => {
      try {
        await this.setState({
          showall: !this.state.showall
          // showritten: false
        });
      } catch (err) {
        alert(err);
      }
    };
    ShowAllTop50 = async () => {
      try {
        await this.setState({
          showalltop50: !this.state.showalltop50
          //showritten: false
        });
      } catch (err) {
        alert(err);
      }
    };

    ShowRitten = async () => {
      try {
        await this.setState({ showritten: !this.state.showritten });
      } catch (err) {
        alert(err);
      }
    };

    ShowOpenstaand = async () => {
      try {
        await this.setState({ openstaand: !this.state.openstaand });
      } catch (err) {
        alert(err);
      }
    };

    showtelefoonopdrachten = async () => {
      try {
        await this.setState({
          showtelefoonopdrachten: !this.state.showtelefoonopdrachten
        });
      } catch (err) {
        alert(err);
      }
    };
    ShowTeDupliceren = async () => {
      try {
        await this.setState({
          showtedupliceren: !this.state.showtedupliceren
        });
      } catch (err) {
        alert(err);
      }
    };

    ShowRetourTeBoeken = async () => {
      try {
        await this.setState({
          showretourteboeken: !this.state.showretourteboeken
        });
      } catch (err) {
        alert(err);
      }
    };

    ShowOngemaild = async () => {
      try {
        await this.setState({
          showongemaild: !this.state.showongemaild
        });
      } catch (err) {
        alert(err);
      }
    };

    ClearFilter = async () => {
      try {
        await this.setState({
          currentFilter: ""
        });
      } catch (err) {
        alert(err);
      }
    };

    render() {
      //let gebruikersNaam = "";
      //let gebruikersrollen = "";
      // const { disabled } = this.state;
      let children = undefined;
      const { classes, gebruikersNaam, gebruikersrollen } = this.props;
      //var query = opdrachten.orderBy("Datum");

      const { docs } = opdrachten;

      //Moet hier nog een promise omheen ????
      // const { isLoading } = opdrachten;

      const klusarr = [
        "Chauffeur",
        "ChauffeurInstellingen",
        "Boodschap",
        "Tuin",
        "Electra",
        "Techniek",
        "Timmeren",
        "Wandelen",
        "Lief_en_leed",
        "Algemeneklusjes",
        "KlussenInstellingen",
        "Nieuwe opdracht"
      ];
      // console.log(klusarr);

      // const achtergrondkleuren = [
      //   '#0000FF',
      //   '#0080FF',
      //   '#00FFFF',
      //   '#8000FF',
      //   '#FF0000',
      //   '#FF8000',
      //   '#FFFF00',
      //   '#80FF00',
      //   '#00FF00',
      //   '#00FF80',
      //   'FF00FF'
      // ];
      //https://www.w3schools.com/colors/colors_wheels.asp
      const voorgrondkleuren = [
        "Red",
        "Blue",
        "Red",
        "#FC600A",
        "Purple",
        "#FCCC1A",
        "Yellow",
        "#B2D732",
        "Orange",
        "#347C98",
        "Green",
        "#4424D6"
      ];
      // const achtergrondkleuren = [
      //   'White',
      //   'White',
      //   'White',
      //   'White',
      //   'White',
      //   'White',
      //   'White',
      //   'White',
      //   'White',
      //   'White',
      //   'White',
      //   'Gold'
      // ];

      //console.log(kleuren);
      var days = ["Zon", "Maa", "Din", "Woe", "Don", "Vri", "Zat"];
      children = docs.map(function(opdracht) {
        if (opdracht.data.datumopdracht === undefined) {
          //lbJzfOyF3KWfy8sncLfq
          opdracht.data.datumopdracht = new Date("7-7-2077").toLocaleDateString(
            "nl-NL"
          );
          alert("Bel Pierre probleem met opdracht " + opdracht.id);
        }
        return {
          ID: opdracht.id,
          timestamp: opdracht.data.timestamp,
          initialen: opdracht.data.initialen || "",
          voornaam: opdracht.data.voornaam || "",
          tussenvoegsel: opdracht.data.tussenvoegsel
            ? opdracht.data.tussenvoegsel.toString().toLowerCase()
            : "",
          achternaam: opdracht.data.achternaam,
          adres: opdracht.data.adres,
          postcode: opdracht.data.postcode,
          woonplaats: opdracht.data.woonplaats,
          telefoon: opdracht.data.telefoon,
          geslacht: opdracht.data.geslacht || "",
          huisnummer: opdracht.data.huisnummer || "",
          opmerking: opdracht.data.opmerking || "",
          geenenkelereis: opdracht.data.geenenkelereis || false,
          datumopdracht: "1-1-1900",
          // opdracht.data.datumopdracht.indexOf('-') > -1
          //   ? opdracht.data.datumopdracht
          //   : new Date(opdracht.data.datumopdracht).toLocaleDateString('nl-NL'),
          klantid: opdracht.data.klantid || "",
          dagopdracht:
            new Date(opdracht.data.uitvoeringsdatum) instanceof Date
              ? days[new Date(opdracht.data.uitvoeringsdatum).getDay()]
              : "Onbekend",
          datumgereed: opdracht.data.datumgereed,
          eindeherhaling: opdracht.data.eindeherhalingtimestamp,
          zz_lastupdate_timestamp:
            opdracht.data.zz_lastupdate_timestamp || Date.now() - 1000000,
          uitvoeringsdatum: new Date(
            opdracht.data.uitvoeringsdatum
          ).toLocaleDateString("nl-NL"),
          uitvoeringsdatumtimestamp: opdracht.data.uitvoeringsdatumtimestamp,
          typeopdracht: opdracht.data.typeopdracht,
          huisnummer_bestemming: opdracht.data.huisnummer_bestemming || "",
          huisnummer_ophaal: opdracht.data.huisnummer_ophaal || "",
          postcode_bestemming: opdracht.data.postcode_bestemming || "",
          postcode_ophaal: opdracht.data.postcode_ophaal || "",
          vrijwilliger: opdracht.data.vrijwilliger || "",
          emailvrijwilliger: opdracht.data.emailvrijwilliger || "",
          ophaaladres: opdracht.data.ophaaladres,
          bestemming: opdracht.data.bestemming,
          gedupliceerd: opdracht.data.gedupliceerd || "Nee",
          herhaling: opdracht.data.herhaling ? "Ja" : "Nee",
          herhaling1week: opdracht.data.herhaling1week,
          herhaling2week: opdracht.data.herhaling2week,
          opdracht: opdracht,
          hour: opdracht.data.hour,
          minute: opdracht.data.minute,
          retourgeboekt: opdracht.data.retourgeboekt ? "Ja" : "Nee",
          geemaild: opdracht.data.geemaild ? "Ja" : "Nee",
          opdrachtuitgevoerd: opdracht.data.opdrachtuitgevoerd ? "Ja" : "Nee",
          emailverstuurd: opdracht.data.emailverstuurd
            ? "Ja"
            : opdracht.data.geemaild
              ? "Opnieuw"
              : "",

          tijdstip:
            opdracht.data.hour === undefined || opdracht.data.hour === 0
              ? ""
              : opdracht.data.hour + ":" + opdracht.data.minute
        };
      });

      var filteredretourteboeken = children.filter(function(opdracht) {
        //console.log(children);
        return opdracht.retourgeboekt === "Nee";
      });

      var filteredongemaild = children.filter(function(opdracht) {
        //console.log(children);
        return opdracht.geemaild === "Nee";
      });

      var filteredtedupliceren = children.filter(function(opdracht) {
        //console.log(children);
        return opdracht.gedupliceerd === "Nee" && opdracht.herhaling === "Ja";
        //return opdracht;
      });

      var filteredopenstaand = children.filter(function(opdracht) {
        //console.log(children);
        //console.log('Openstaand');
        return opdracht.gedupliceerd === "Nee";
        //return opdracht.typeopdracht == -"Chauffeur";
        // opdracht.opdrachtuitgevoerd === "Nee" &&
        //
        //return opdracht;
      });

      const RetryStuurEmail = row => {
        firebase
          .firestore()
          .collection("opdrachten")
          .doc(row.original.ID)
          .update({ retry: true })
          .then(function(err) {
            toast.info(`Email wordt opnieuw verzonden.`, {
              position: "top-center",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true
            });
          });
      };

      const ZetAfgemeld = row => {
        firebase
          .firestore()
          .collection("opdrachten")
          .doc(row.original.ID)
          .update({
            opdrachtuitgevoerd: true,
            datumgereed: new Date().toISOString().substr(0, 10)
          })
          .then(function(err) {
            toast.info(`Opdrachtuitgevoerd.`, {
              position: "top-center",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true
            });
          });
      };

      const ZetAangemeld = row => {
        firebase
          .firestore()
          .collection("opdrachten")
          .doc(row.original.ID)
          .update({
            opdrachtuitgevoerd: false,
            datumgereed: firebase.firestore.FieldValue.delete()
          })
          .then(function(err) {
            toast.info(`Opdracht weer op niet uitgevoerd gezet.`, {
              position: "top-center",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true
            });
          });
      };

      const StuurEmail = row => {
        //console.log(row.original.ID);
        let stuuremail = false;
        if (
          row.original.typeopdracht.startsWith("Chauffeur") &&
          row.original.retourgeboekt
        ) {
          stuuremail = true;
        }
        if (!row.original.typeopdracht.startsWith("Chauffeur")) {
          stuuremail = true;
        }

        if (stuuremail) {
          firebase
            .firestore()
            .collection("opdrachten")
            .doc(row.original.ID)
            .update({ geemaild: true })
            .then(function(err) {
              toast.info(`Email wordt verzonden.`, {
                position: "top-center",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true
              });
            });
        } else {
          alert(
            "Rit is niet retour geboekt. Boek retour rit. In het geval van een enkele rit dan de retour rit aanmkaen en verwijderen."
          );
        }
      };

      const BoekRetour = row => {
        const gebruikersNaam = "onbekend";
        if (row.original.retourgeboekt === true) {
          alert("Rit is reeds retour geboekt.");
        } else {
          if (!this.state.showretourteboeken) {
            this.setState({ currentFilter: row.original.achternaam });
          }
          firebase
            .firestore()
            .collection("opdrachten")
            .doc(row.original.ID)
            .update({ retourgeboekt: true })
            .then(function(err) {
              //alert("Retour geboekt");
            });
          opdrachten
            .add({
              typeopdracht: row.original.typeopdracht,
              geslacht: row.original.geslacht,
              initialen: row.original.initialen,
              voornaam: row.original.voornaam,
              tussenvoegsel: row.original.tussenvoegsel,
              achternaam: row.original.achternaam,
              adres: row.original.adres,
              postcode: row.original.postcode,
              woonplaats: row.original.woonplaats,
              telefoon: row.original.telefoon,
              hour: 0,
              minute: 0,
              vrijwilliger: row.original.vrijwilliger,
              emailvrijwilliger: row.original.emailvrijwilliger,
              opmerking: row.original.opmerking || "",
              klantid: row.original.klantid,
              timestamp: Date.now(),
              ophaaladres: row.original.bestemming,
              bestemming: row.original.ophaaladres,
              huisnummer_bestemming: row.original.huisnummer_ophaal,
              huisnummer_ophaal: row.original.huisnummer_bestemming,
              postcode_ophaal: row.original.postcode_bestemming,
              postcode_bestemming: row.original.postcode_ophaal,
              origineleboeking: row.original.ID,
              retourgeboekt: true,
              //uitvoeringsdatum: nieuwedatum,
              herhaling: row.original.herhaling === "Ja" ? true : false,
              herhaling1week: row.original.herhaling1week,
              herhaling2week: row.original.herhaling2week,
              datumopdracht: new Date().toDateString("yyyy-MM-dd"),
              zz_lastupdate_timestamp: Date.now(),
              zz_gebruikersNaam: gebruikersNaam
            })
            .then(function(err) {
              toast.info(`Retouropdracht is aangemaakt.`, {
                position: "top-center",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true
              });
            });
        }
      };

      // const addDays = (startDate, numberOfDays) => {
      //   var returnDate = new Date(
      //     startDate.getFullYear(),
      //     startDate.getMonth(),
      //     startDate.getDate() + numberOfDays,
      //     startDate.getHours(),
      //     startDate.getMinutes(),
      //     startDate.getSeconds()
      //   );
      //   return returnDate;
      // };

      const jaarmaanddagFormat = startDate => {
        const sd = new Date(startDate);
        let maand = (sd.getMonth() + 1).toString();
        if (maand.length === 1) {
          maand = "0" + maand;
        }
        let dag = sd.getDate().toString();
        if (dag.length === 1) {
          dag = "0" + dag;
        }

        var returnDate = sd.getFullYear() + "-" + maand + "-" + dag;

        return returnDate;
      };

      const Dupliceer = row => {
        const gebruikersNaam = "onbekend";

        //Mogen we nog dupliceren?

        const eindeherhaling = row.original.eindeherhaling;
        // alert(eindeherhaling);
        const nu = Date.now();
        let stop = false;
        if (eindeherhaling) {
          if (nu > eindeherhaling + 24 * 60 * 60 * 1000) {
            stop = true;
            firebase
              .firestore()
              .collection("opdrachten")
              .doc(row.original.ID)
              .update({ herhaling: false })
              .then(() => {
                const err =
                  "Nieuwe herhalingsopdrachten zijn niet meer mogelijk voor deze opdracht. Einddatum is ingesteld op " +
                  new Date(eindeherhaling).toLocaleDateString("nl-NL");

                toast.error(`Fout: ${err}`, {
                  position: "top-center",
                  autoClose: 10000,
                  hideProgressBar: false,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true
                });
                return false;
              });
          }
        }

        if (!stop) {
          firebase
            .firestore()
            .collection("opdrachten")
            .doc(row.original.ID)
            .update({ gedupliceerd: "Ja" })
            .then(function(err) {
              //alert("Retour geboekt");
            });

          let nieuwedatum = new Date();
          //let omgezettedatumfromts = new Date(row.original.uitvoeringsdatumtimestamp);
          let nieuwedatumts = Date.now();
          //console.log("Huidige datum", row.original.uitvoeringsdatum);
          //console.log("Huidige datum timestamp", omgezettedatumfromts);
          // let omgezettedatum = `${new Date(row.original.uitvoeringsdatumtimestamp).getFullYear()}-${new Date(
          //   row.original.uitvoeringsdatumtimestamp
          // ).getMonth()}-${new Date(row.original.uitvoeringsdatumtimestamp).getDay()}`;

          // console.log('Omgezette datum', omgezettedatum);

          if (row.original.herhaling1week === true) {
            //nieuwedatum = addDays(new Date(row.original.uitvoeringsdatumsdatumtimestamp), 7);
            nieuwedatumts =
              row.original.uitvoeringsdatumtimestamp + 7 * 24 * 60 * 60 * 1000; // zorg er voor dat de tijdzone gecomseerd word
            nieuwedatum = new Date(nieuwedatumts).toDateString("yyyy-MM-dd");
            //console.log("Nieuwe datum 1 week", nieuwedatum);
          }
          if (row.original.herhaling2week === true) {
            // nieuwedatum = addDays(new Date(omgezettedatum), 14);
            nieuwedatumts =
              row.original.uitvoeringsdatumtimestamp + 14 * 24 * 60 * 60 * 1000;
            nieuwedatum = new Date(nieuwedatumts).toDateString("yyyy-MM-dd");
            //console.log("Nieuwe datum 2 week", nieuwedatum);
          }
          //console.log("Nieuwe datum", nieuwedatum);

          opdrachten
            .add({
              typeopdracht: row.original.typeopdracht,
              achternaam: row.original.achternaam,
              tussenvoegsel: row.original.tussenvoegsel,
              geslacht: row.original.geslacht,
              initialen: row.original.initialen,
              huisnummer: row.original.huisnummer,
              adres: row.original.adres,
              postcode: row.original.postcode,
              woonplaats: row.original.woonplaats,
              telefoon: row.original.telefoon,
              hour: row.original.hour || 0,
              minute: row.original.minute || 0,
              vrijwilliger: row.original.vrijwilliger,
              emailvrijwilliger: row.original.emailvrijwilliger,
              opmerking: row.original.opmerking || "",
              klantid: row.original.klantid,
              timestamp: nu,
              ophaaladres: row.original.ophaaladres,
              bestemming: row.original.bestemming,
              huisnummer_bestemming: row.original.huisnummer_bestemming,
              huisnummer_ophaal: row.original.huisnummer_ophaal,
              postcode_ophaal: row.original.postcode_ophaal,
              postcode_bestemming: row.original.postcode_bestemming,
              uitvoeringsdatum: jaarmaanddagFormat(nieuwedatum),
              uitvoeringsdatumtimestamp: nieuwedatumts,
              herhaling: true,
              herhaling1week: row.original.herhaling1week || false,
              herhaling2week: row.original.herhaling2week || false,
              datumopdracht: new Date().toDateString("yyyy-MM-dd"),
              zz_gebruikersNaam: gebruikersNaam,
              zz_lastupdate_timestamp: Date.now()
            })
            .then(function(ok) {
              //console.log(ok);
              toast.info(`Opdracht is gedupliceerd.`, {
                position: "top-center",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true
              });
              if (
                !row.original.herhaling1week &&
                !row.original.herhaling2week
              ) {
                const alerttekst = `Let op!!\n\nDeze opdracht van ${
                  row.original.achternaam
                } van het type ${row.original.typeopdracht} met opmerking\n\n${
                  row.original.opmerking
                }\n\nheeft geen vaste herhaaltermijn. Gaarne deze opdracht handmatig te wijzigen`;
                alert(alerttekst);
              }
            })
            .catch(function(err) {
              toast.info(`Fout: ${err}`, {
                position: "top-center",
                autoClose: 10000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true
              });
            });
          //console.log(row);
        }
      };

      return (
        <div>
          <div align="left" style={{ paddingRight: 20, paddingBottom: 15 }}>
            {/* <Button
              //variant="fab"
              variant="contained"
              size="medium"
              color={this.state.showretourteboeken ? "primary" : "default"}
              //aria-label="add"
              className={classes.button}
              disabled={this.props.gebruikersrollen.search("pierre") === -1}
              onClick={this.ShowRetourTeBoeken}
              style={{ marginTop: 0, marginRight: 0, marginLeft: 20 }}
            >
              Geen retour geboekt
            </Button> */}
            <Button
              //variant="fab"
              variant="contained"
              size="medium"
              color={this.state.showongemaild ? "primary" : "default"}
              //aria-label="add"
              className={classes.button}
              disabled={
                this.props.gebruikersrollen.search("editopdrachten") === -1
              }
              onClick={this.ShowOngemaild}
              style={{ marginTop: 0, marginRight: 20, marginLeft: 20 }}
            >
              Geen email verzonden
            </Button>
            <Button
              //variant="fab"
              variant="contained"
              size="medium"
              color={this.state.openstaand ? "primary" : "default"}
              //aria-label="add"
              className={classes.button}
              disabled={
                this.props.gebruikersrollen.search("editopdrachten") === -1
              }
              onClick={this.ShowOpenstaand}
              style={{ marginTop: 0, marginRight: 20, marginLeft: 20 }}
            >
              Openstaande opdrachten
            </Button>
            <Button
              //variant="fab"
              variant="contained"
              size="medium"
              color={this.state.showritten ? "primary" : "default"}
              //aria-label="add"
              className={classes.button}
              disabled={
                this.props.gebruikersrollen.search("editopdrachten") === -1
              }
              onClick={this.ShowRitten}
              style={{ marginTop: 0, marginRight: 20 }}
            >
              Chauffeur + vast
            </Button>
            <Button
              //variant="fab"
              variant="contained"
              size="medium"
              color={this.state.showtelefoonopdrachten ? "primary" : "default"}
              //aria-label="add"
              className={classes.button}
              disabled={
                this.props.gebruikersrollen.search("editopdrachten") === -1
              }
              onClick={this.showtelefoonopdrachten}
              style={{ marginTop: 0, marginRight: 20 }}
            >
              Telefoon opdrachten
            </Button>

            <Button
              //variant="fab"
              variant="contained"
              size="medium"
              color={this.state.showalltop50 ? "primary" : "default"}
              //aria-label="add"
              className={classes.button}
              disabled={
                this.props.gebruikersrollen.search("editopdrachten") === -1
              }
              onClick={this.ShowAllTop50}
              style={{ marginTop: 0, marginRight: 20 }}
            >
              Opdrachten top 150
            </Button>
            <Button
              //variant="fab"
              variant="contained"
              size="medium"
              color={this.state.showtedupliceren ? "primary" : "default"}
              //aria-label="add"
              className={classes.button}
              disabled={
                this.props.gebruikersrollen.search("editopdrachten") === -1
              }
              onClick={this.ShowTeDupliceren}
              style={{ marginTop: 0, marginRight: 20 }}
            >
              {/* {this.state.showall
                ? "Actieve opdrachten"
                : "Toon alle opdrachten"} */}
              Te dupliceren opdrachten
            </Button>
            <Button
              //variant="fab"
              variant="contained"
              size="medium"
              color={this.state.showall ? "primary" : "default"}
              //aria-label="add"
              className={classes.button}
              disabled={
                this.props.gebruikersrollen.search("editopdrachten") === -1
              }
              onClick={this.ShowAll}
              style={{ marginTop: 0, marginRight: 20 }}
            >
              {/* {this.state.showall
                ? "Actieve opdrachten"
                : "Toon alle opdrachten"} */}
              Alle opdrachten
            </Button>
            <Button
              //variant="fab"
              variant="contained"
              size="medium"
              //color={this.state.showall ? "primary" : "primary"} // deze regel slaat nergens op want er is geen state voor deze knop
              color="secondary"
              //aria-label="add"
              className={classes.button}
              disabled={
                this.props.gebruikersrollen.search("editopdrachten") === -1
              }
              onClick={this.ClearFilter}
              style={{ marginTop: 0, marginRight: 20 }}
            >
              {/* {this.state.showall
                ? "Actieve opdrachten"
                : "Toon alle opdrachten"} */}
              Verwijder naam filter
            </Button>

            {/* <Button
              //variant="fab"
              variant="contained"
              size="medium"
              color="primary"
              //aria-label="add"
              className={classes.button}
              disabled={this.props.gebruikersrollen.search('editopdrachten') === -1 || !this.state.showalltop50}
              onClick={this.onPressAdd}
              style={{ marginTop: 0, marginLeft: 200 }}
            >
              Voeg opdracht toe
            </Button> */}
          </div>
          <ReactTable
            data={
              this.state.showretourteboeken
                ? filteredretourteboeken
                : this.state.showongemaild
                  ? filteredongemaild
                  : this.state.showtedupliceren
                    ? filteredtedupliceren
                    : this.state.showopenstaand
                      ? filteredopenstaand
                      : children
            }
            previousText="Vorige"
            nextText="Volgende"
            loadingText="Laden..."
            noDataText="Geen rijen gevonden"
            pageText="Pagina"
            ofText="van"
            rowsText="rijen"
            filterable
            //style={{ backgroundColor: "gold" }}
            filtered={[
              {
                id: "achternaam",
                // value: window.clipboardData.getData('Text')
                value: this.state.currentFilter
              }
            ]}
            //onChange={this.onChangeTable}
            onFilteredChange={(filtered, column) => {
              if (filtered[0]) {
                //console.log(filtered[0].value);
                this.setState({ currentFilter: filtered[0].value });
                //if filtered[0].value.length === 1
              } else {
                this.setState({ currentFilter: "" });
              }
            }}
            defaultSorted={[
              {
                id: "timestamp",
                desc: true
              }
            ]}
            defaultFilterMethod={(filter, row) =>
              String(row[filter.id]) === filter.value
            }
            SubComponent={row => {
              return (
                <Opdracht
                  key={row.original.ID}
                  opdracht={row.original.opdracht}
                  gebruikersNaam={gebruikersNaam}
                  gebruikersrollen={gebruikersrollen}
                />
              );
            }}
            columns={[
              // {
              //   getProps: (state, rowInfo, column) => {
              //     return {
              //       style: {
              //         background:
              //           rowInfo.row.typeopdracht === "Chauffeur"
              //             ? "green"
              //             : null
              //       }
              //     };
              //   }
              // },
              {
                Header: "ID",
                columns: [
                  {
                    Header: "ID",
                    accessor: "ID",
                    width: 150,
                    filterable: true,
                    show: false
                  }
                ]
              },
              {
                Header: "TS",
                columns: [
                  {
                    Header: "ts",
                    accessor: "timestamp",
                    // Cell: row => <div>{new Date(row.value)}</div>,
                    width: 150,
                    filterable: true,
                    show: false
                  }
                ]
              },
              {
                Header: "Naam",
                columns: [
                  // {
                  //   Header: "Initialen",
                  //   accessor: "initialen",
                  //   width: 100,
                  //   filterMethod: (filter, rows) =>
                  //     matchSorter(rows, filter.value, { keys: ["initialen"] }),
                  //   filterAll: true
                  // },
                  // {
                  //   Header: "Voornaam",
                  //   accessor: "voornaam",
                  //   width: 100,
                  //   filterMethod: (filter, rows) =>
                  //     matchSorter(rows, filter.value, { keys: ["voornaam"] }),
                  //   filterAll: true
                  // },
                  // {
                  //   Header: "tussenvoegsel",
                  //   accessor: "tussenvoegsel",
                  //   width: 100,
                  //   filterMethod: (filter, rows) =>
                  //     matchSorter(rows, filter.value, {
                  //       keys: ["tussenvoegsel"]
                  //     }),
                  //   filterAll: true
                  // },
                  {
                    Header: "Datum opdracht",
                    accessor: "timestamp",
                    filterable: false,
                    width: 100,
                    Cell: row => (
                      <span style={{ height: "100%", width: "100%" }}>
                        {row.value !== "Invalid Date" ? (
                          new Date(row.value).toLocaleDateString("nl-NL")
                        ) : (
                          <div
                            align="center"
                            style={{
                              borderRadius: "5px",
                              backgroundColor: "#FDAEBE",
                              height: "100%"
                            }}
                          >
                            ---
                          </div>
                        )}
                      </span>
                    ),
                    filterMethod: (filter, rows) =>
                      matchSorter(rows, filter.value, {
                        keys: ["timestamp"]
                      }),
                    filterAll: true
                  },
                  {
                    Header: "tsvgsl",
                    accessor: "tussenvoegsel",
                    filterable: false,
                    width: 50
                  },
                  {
                    Header: "Achternaam",
                    accessor: "achternaam",
                    width: 100,

                    filterMethod: (filter, rows) =>
                      matchSorter(rows, filter.value, { keys: ["achternaam"] }),
                    filterAll: true
                  }
                ]
              },
              {
                Header: "Adres",
                columns: [
                  {
                    Header: "Straat",
                    accessor: "adres",
                    filterable: false,
                    width: 100,
                    filterMethod: (filter, rows) =>
                      matchSorter(rows, filter.value, { keys: ["adres"] }),
                    filterAll: true
                  },
                  {
                    Header: "Postcode",
                    accessor: "postcode",
                    filterable: false,
                    width: 100,
                    filterMethod: (filter, rows) =>
                      matchSorter(rows, filter.value, { keys: ["postcode"] }),
                    filterAll: true,
                    show: false
                  },
                  {
                    Header: "Woonplaats",
                    accessor: "woonplaats",
                    filterable: false,
                    width: 100,
                    filterMethod: (filter, rows) =>
                      matchSorter(rows, filter.value, { keys: ["woonplaats"] }),
                    filterAll: true,
                    show: false
                  }
                ]
              },
              {
                Header: "Diversen",
                columns: [
                  {
                    Header: "Telefoon",
                    accessor: "telefoon",
                    filterable: false,
                    width: 100,
                    filterMethod: (filter, rows) =>
                      matchSorter(rows, filter.value, { keys: ["telefoon"] }),
                    filterAll: true
                  },
                  {
                    Header: "Type opdracht",
                    accessor: "typeopdracht",
                    filterable: false,
                    Cell: row => (
                      <div
                        style={{
                          // backgroundColor:
                          //   achtergrondkleuren[klusarr.indexOf(row.value)],
                          color: voorgrondkleuren[klusarr.indexOf(row.value)]
                          //transition: 'all .3s ease'
                        }}
                      >
                        {" "}
                        {row.value}
                      </div>
                    ),
                    width: 100,
                    filterMethod: (filter, rows) =>
                      matchSorter(rows, filter.value, {
                        keys: ["typeopdracht"]
                      }),
                    filterAll: true
                  },
                  {
                    Header: "Datum uitvoering",
                    accessor: "uitvoeringsdatumtimestamp",
                    filterable: false,
                    width: 100,
                    filterMethod: (filter, rows) =>
                      matchSorter(rows, filter.value, {
                        keys: ["uitvoeringsdatumtimestamp"]
                      }),
                    Cell: row => (
                      <span style={{ height: "100%", width: "100%" }}>
                        {row.value !== "Invalid Date" ? (
                          new Date(row.value).toLocaleDateString("nl-NL")
                        ) : (
                          <div
                            align="center"
                            style={{
                              borderRadius: "5px",
                              backgroundColor: "#FDAEBE",
                              height: "100%"
                            }}
                          >
                            ---
                          </div>
                        )}
                      </span>
                    ),
                    filterAll: true
                  },
                  {
                    Header: "Dag",
                    accessor: "dagopdracht",
                    filterable: false,
                    width: 50,
                    filterMethod: (filter, rows) =>
                      matchSorter(rows, filter.value, {
                        keys: ["dagopdracht"]
                      }),
                    Cell: row => (
                      <span style={{ height: "100%", width: "100%" }}>
                        {row.value ? (
                          row.value
                        ) : (
                          <div
                            align="center"
                            style={{
                              borderRadius: "5px",
                              backgroundColor: "#FDAEBE",
                              height: "100%"
                            }}
                          />
                        )}
                      </span>
                    ),
                    filterAll: true
                  },
                  {
                    Header: "Tijd",
                    accessor: "tijdstip",
                    filterable: false,
                    width: 50,
                    filterMethod: (filter, rows) =>
                      matchSorter(rows, filter.value, {
                        keys: ["tijdstip"]
                      }),
                    Cell: row => (
                      <span style={{ height: "100%", width: "100%" }}>
                        {row.value !== "" ? (
                          row.value
                        ) : (
                          <div
                            align="center"
                            style={{
                              borderRadius: "5px",
                              backgroundColor: "#FDAEBE",
                              height: "100%"
                            }}
                          />
                        )}
                      </span>
                    ),
                    filterAll: true
                  },
                  {
                    Header: "Vrijwilliger",
                    accessor: "vrijwilliger",
                    filterable: false,
                    width: 100,
                    Cell: row => (
                      <span style={{ height: "100%", width: "100%" }}>
                        {row.value ? (
                          row.value
                        ) : (
                          <div
                            align="center"
                            style={{
                              borderRadius: "5px",
                              backgroundColor: "#FDAEBE",
                              height: "100%"
                            }}
                          />
                        )}
                      </span>
                    ),
                    filterMethod: (filter, rows) =>
                      matchSorter(rows, filter.value, {
                        keys: ["vrijwilliger"]
                      }),
                    filterAll: true
                  },
                  {
                    Header: "Herhaling",
                    accessor: "herhaling",
                    filterable: false,
                    Cell: row => (
                      <span>
                        <span
                          style={{
                            color: row.value === "Ja" ? "#57d500" : "#ff0000",
                            transition: "all .3s ease"
                          }}
                        >
                          &#x25cf;
                        </span>{" "}
                        {row.value}
                      </span>
                    ),
                    width: 100,
                    filterMethod: (filter, rows) =>
                      matchSorter(rows, filter.value, {
                        keys: ["herhaling"]
                      }),
                    filterAll: true
                  },
                  {
                    Header: "Dupliceren",
                    accessor: "herhaling",
                    filterable: false,
                    Cell: row => (
                      <span>
                        {row.value === "Ja" ? (
                          row.original.gedupliceerd === "Ja" ? (
                            <Done style={{ color: "green" }} />
                          ) : (
                            <AddCircle onClick={() => Dupliceer(row)} />
                          )
                        ) : null}
                      </span>
                    ),
                    width: 50
                    // filterMethod: (filter, rows) =>
                    //   matchSorter(rows, filter.value, {
                    //     keys: ['herhaling']
                    //   }),
                    // filterAll: true
                  },
                  {
                    Header: "Retour",
                    accessor: "retourgeboekt",
                    filterable: false,
                    Cell: row => (
                      <span align="center">
                        {row.value === "Ja" ? (
                          <Done style={{ color: "green" }} />
                        ) : (row.original.typeopdracht.startsWith(
                          "Chauffeur"
                        ) &&
                          row.original.herhaling === true) ||
                        row.original.geenenkelereis === true ? (
                          <ImportExport
                            style={{ color: "blue" }}
                            onClick={() => BoekRetour(row)}
                          />
                        ) : null}
                      </span>
                    ),
                    width: 50
                    // filterMethod: (filter, rows) =>
                    //   matchSorter(rows, filter.value, {
                    //     keys: ['herhaling']
                    //   }),
                    // filterAll: true
                  },
                  {
                    Header: "Nieuw",
                    accessor: "timestamp",
                    filterable: false,
                    Cell: row => (
                      <span style={{ color: "green" }}>
                        {Date.now() - row.value > 1800000 ? "" : <New />}
                      </span>
                    ),
                    width: 50
                    // filterMethod: (filter, rows) =>
                    //   matchSorter(rows, filter.value, {
                    //     keys: ['herhaling']
                    //   }),
                    // filterAll: true
                  },
                  {
                    Header: "Gewijzigd",
                    accessor: "zz_lastupdate_timestamp",
                    filterable: false,
                    Cell: row => (
                      <span style={{ height: "100%" }}>
                        {row.value - Date.now() < -300000 ? null : (
                          <div
                            align="center"
                            style={{
                              backgroundColor: "orange",
                              height: "100%"
                            }}
                          >
                            <Done style={{ color: "green" }} />
                          </div>
                        )}
                      </span>
                      // <span style={{ color: "green" }}>
                      //   {row.value - Date.now() < 300000 ? <Done /> : ""}
                      // </span>
                    ),
                    width: 50
                    // filterMethod: (filter, rows) =>
                    //   matchSorter(rows, filter.value, {
                    //     keys: ['herhaling']
                    //   }),
                    // filterAll: true
                  },
                  {
                    Header: "Emailen",
                    accessor: "geemaild",
                    filterable: false,
                    Cell: row => (
                      <span>
                        {row.value === "Ja" ? (
                          <Done style={{ color: "green" }} />
                        ) : row.original.typeopdracht &&
                        row.original.uitvoeringsdatumtimestamp &&
                        row.original.hour &&
                        row.original.vrijwilliger ? (
                          // ||
                          // (row.original.typeopdracht &&
                          //   row.original.typeopdracht.startsWith("Chauffeur") &&
                          //   row.original.retourgeboekt === "Ja" &&
                          //   row.original.uitvoeringsdatumtimestamp &&
                          //   row.original.hour &&
                          //   row.original.vrijwilliger)
                          <EmailOutlined
                            style={{ color: "blue" }}
                            onClick={() => StuurEmail(row)}
                          />
                        ) : null}
                      </span>
                    ),
                    width: 50
                  },
                  {
                    Header: "Verstuurd",
                    accessor: "emailverstuurd",
                    filterable: false,
                    Cell: row => (
                      <span>
                        <span
                          style={{
                            color: row.value === "Ja" ? "#57d500" : "#ffffff",
                            transition: "all .3s ease"
                          }}
                        >
                          &#x25cf;
                        </span>{" "}
                        {row.value === "Ja" ? (
                          "Ja"
                        ) : row.original.emailverstuurd ? (
                          <EmailOutlined
                            style={{ color: "red" }}
                            onClick={() => RetryStuurEmail(row)}
                          />
                        ) : (
                          ""
                        )}
                      </span>
                    ),
                    width: 50,
                    filterMethod: (filter, rows) =>
                      matchSorter(rows, filter.value, {
                        keys: ["emailverstuurd"]
                      }),
                    filterAll: true
                  },
                  {
                    Header: "Uitgevoerd?",
                    accessor: "opdrachtuitgevoerd",
                    filterable: false,
                    Cell: row => (
                      <span>
                        <span
                          style={{
                            color: row.value === "Ja" ? "#57d500" : "#ff0000",
                            transition: "all .3s ease"
                          }}
                        >
                          &#x25cf;
                        </span>{" "}
                        {row.value === "Ja" ? (
                          this.props.gebruikersrollen.search("afmelden") >
                          -1 ? (
                            <DoneOutline
                              style={{ color: "green" }}
                              onClick={() => ZetAangemeld(row)}
                            />
                          ) : (
                            "Ja"
                          )
                        ) : row.original.opdrachtuitgevoerd ? (
                          this.props.gebruikersrollen.search("afmelden") >
                          -1 ? (
                            <OfflinePin
                              style={{ color: "red" }}
                              onClick={() => ZetAfgemeld(row)}
                            />
                          ) : (
                            "Nee"
                          )
                        ) : (
                          "Weet het niet"
                        )}
                      </span>
                    ),
                    width: 50,
                    filterMethod: (filter, rows) =>
                      matchSorter(rows, filter.value, {
                        keys: ["opdrachtuitgevoerd"]
                      }),
                    filterAll: true
                  }
                ]
              }
            ]}
            defaultPageSize={10}
            className="-striped -hightlight"
          />
          <Paper
            style={{ marginLeft: "200px", marginRight: "200px", marginTop: 30 }}
          >
            U bent ingelogd als {gebruikersNaam} en heeft de rollen{" "}
            {gebruikersrollen}
          </Paper>
          <ToastContainer
            position="top-center"
            transition={Zoom}
            autoClose={2000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick={false}
            rtl={false}
            pauseOnVisibilityChange
            draggable
            pauseOnHover
            closeButton={false}
          />
        </div>
      );
    }
  }
);

export default withStyles(styles)(Opdrachten);



// WEBPACK FOOTER //
// ./src/components/Opdrachten/Opdrachten.jsx